const Kookaburra = [
	'Kookaburra sits in the old gum tree,',
	'merry, merry king of the bush is he',
	'Laugh kookaburra, laugh',
	'Kookaburra, gay your life must be',
	'',
	'Kookaburra sits in the old gum tree,',
	'eating all the gumdrops that he can see',
	'Stop, kookaburra, stop',
	'Kookaburra, leave some there for me',
	'',
	'Kookaburra sits in the old gum tree,',
	'chasing all the monkeys he can see',
	'Stop, kookaburra, stop',
	'Kookaburra, that`s not a monkey, that`s me!',
];

export default Kookaburra;
